import React from "react";
import { RouteProps } from "react-router-dom";
import { WPPost } from "../../constants/types";
import { PagePostTypeAcf } from "../../constants/types/acf";
import { useCurrentRouteData } from "../../services/app-state";
import { ErrorBoundary } from "../organisms/ErrorBoundary";
import { AssessmentTemplate } from "./AssessmentTemplate";
import { DirectoryTemplate } from "./DirectoryTemplate";
import { Home } from "./Home";
import { NeedHelpNowTemplate } from "./NeedHelpNowTemplate";
import { Page } from "./Page";
import { SavedItemsTemplate } from "./SavedItemsTemplate";

export const templateFileNames = {
    directory: "template-directory.php",
    needHelpNow: "template-need-help-now.php",
    home: "template-home.php",
    savedItems: "template-saved-items.php",
    assessment: "template-assessment.php",
    page: "",
};

export const isNSWTBPage = (templateName: string | undefined) => {
    return templateName === templateFileNames.assessment;
};

// Add template file names here for pages we don't want a fixed header on
const shouldUseFixedHeader = (page: WPPost | undefined) => {
    const nonFixedHeaderTemplates = [templateFileNames.assessment];
    return !nonFixedHeaderTemplates.includes(page?.template ?? "");
};

// Add template file names here for pages where we want a dark navbar
const shouldUseDarkNavBar = (page: WPPost | undefined) => {
    const darkNavBarTemplates = [templateFileNames.needHelpNow];
    return darkNavBarTemplates.includes(page?.template ?? "");
};

// Add template file names here for pages where we want no underline on the nav
const shouldHideNavUnderline = (page: WPPost | undefined) => {
    const nonUnderlinedNavTemplates = [templateFileNames.assessment];
    return page?.type === "listing" || nonUnderlinedNavTemplates.includes(page?.template ?? "");
};

export const useTemplateThemeVariations = () => {
    const page = useCurrentRouteData() as WPPost | undefined;

    return {
        shouldUseFixedHeader: shouldUseFixedHeader(page),
        shouldUseDarkNavBar: shouldUseDarkNavBar(page),
        shouldHideNavUnderline: shouldHideNavUnderline(page),
    };
};

const getTemplateComponent = (templateName: string) => {
    const templateMapping: Record<string, React.ComponentType<RouteProps>> = {
        [templateFileNames.needHelpNow]: NeedHelpNowTemplate,
        [templateFileNames.directory]: DirectoryTemplate,
        [templateFileNames.page]: Page,
        [templateFileNames.home]: Home,
        [templateFileNames.savedItems]: SavedItemsTemplate,
        [templateFileNames.assessment]: AssessmentTemplate,
    };
    if (templateMapping[templateName]) {
        return templateMapping[templateName];
    }
    return Page;
};

const PageTemplateChooserInner: React.FC<RouteProps> = props => {
    const page = useCurrentRouteData<PagePostTypeAcf>();
    const Component = getTemplateComponent(page.template);
    return <>
    <Component {...props} />
    </>
    ;
};

export const PageTemplateChooser: React.FC<RouteProps> = props => {
    return (
        <ErrorBoundary>
            <PageTemplateChooserInner {...props} />
        </ErrorBoundary>
    );
};
